module.exports = __webpack_public_path__ + "static/media/price.d910d60a.svg";